// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"493":"e9806412e5290d1c","634":"e8f93091839c13ee"}[chunkId] + ".js";
};